import { Component } from '@angular/core';
import {ViewportScroller} from "@angular/common";
import {RouterModule} from "@angular/router";

@Component({
  selector: 'jhi-blog-entry-7',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './blog-entry-7.component.html',
  styleUrl: './blog-entry-7.component.scss'
})
export class BlogEntry7Component {
  constructor(private viewportScroller: ViewportScroller) {
  }

  public scrollTo(anchor: string): void { // for calling to anchors
    this.viewportScroller.scrollToAnchor(anchor);
  }

  ngOnInit() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }

}
